import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { env } from '@/env';

/*
 * T76. Four fields, because this app initialises exactly one Firebase service.
 *
 * ⚠️ THREE FIELDS WERE DELETED HERE AND THEY WERE NOT MERELY UNUSED — the services they configure
 * are not part of this platform at all:
 *
 *   · `storageBucket` (Cloud Storage). **File storage is DigitalOcean Spaces.**
 *     `nexvia-api-web/src/shared/spaces.js` runs two S3-compatible clients — a private bucket for
 *     driver identity documents, a public one for shipment photos — and the API hands this app
 *     pre-signed Spaces URLs, which `DriverDocumentsDialog.tsx:96` renders. `grep -rn storageBucket`
 *     across `nexvia-api-web` returns nothing: the API does not read the Firebase bucket either.
 *   · `messagingSenderId` (FCM). No messaging import anywhere.
 *   · `measurementId` (Analytics). No `firebase/analytics` import anywhere.
 *
 * They were leftovers from pasting the Firebase console's config block in whole, and keeping them
 * was worse than dropping them: a field that is wired up and inert reads as an integration, so the
 * next person goes looking for a Storage layer that does not exist. Same class of defect as F-025's
 * "prefer `api.ts` (axios)" — not a wrong value, a wrong belief that reads as fact.
 *
 * ⚠️ Requiring two of them at boot took `backoffice.dev` down on 2026-09-07, by refusing an
 * environment that was correct. See `src/env.ts`.
 */
const firebaseConfig = {
    apiKey: env.VITE_APP_FIREBASE_API_KEY,
    authDomain: env.VITE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: env.VITE_APP_FIREBASE_PROJECT_ID,
    appId: env.VITE_APP_FIREBASE_APP_ID
};

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

export { firebase };
export default firebase;
